function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M5.25 12.75H9.75M5.25 6.75H8.25M5.25 9.75H9.75",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 9V1.5L11.4655 2.40422C11.0069 2.60804 10.7776 2.70996 10.5455 2.73546C10.291 2.76341 10.0336 2.72577 9.79783 2.62612C9.58278 2.53524 9.39226 2.37194 9.01121 2.04532C8.50521 1.61161 8.2522 1.39475 7.9722 1.30188C7.66561 1.2002 7.33439 1.2002 7.0278 1.30188C6.74779 1.39475 6.49479 1.61161 5.98879 2.04532C5.60774 2.37194 5.41722 2.53524 5.20217 2.62612C4.96635 2.72577 4.70895 2.76341 4.45447 2.73546C4.22241 2.70996 3.9931 2.60804 3.53448 2.40422L1.5 1.5V11.7C1.5 13.3802 1.5 14.2202 1.82698 14.862C2.1146 15.4265 2.57354 15.8854 3.13803 16.173C3.77976 16.5 4.61984 16.5 6.3 16.5H15M13.5 9H14.1C14.9401 9 15.3601 9 15.681 9.16349C15.9632 9.3073 16.1927 9.53677 16.3365 9.81901C16.5 10.1399 16.5 10.5599 16.5 11.4V15C16.5 15.8284 15.8284 16.5 15 16.5M13.5 9V15C13.5 15.8284 14.1716 16.5 15 16.5",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcNewspaperHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewspaperHome);
export default __webpack_public_path__ + "static/media/ic_newspaper_home.fa874726.svg";
export { ForwardRef as ReactComponent };